import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { LINKS } from "@/lib/site";
import { FounderRecord } from "./FounderRecord";

export const Founder = () => {
  return (
    <section className="bg-surface-dark border-y border-ink" data-testid="founder-section">
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-2 md:border-x border-ink">
        <div className="founder-record-panel relative overflow-hidden bg-ink text-paper border-b lg:border-b-0 lg:border-r border-ink">
          <div
            className="absolute inset-0 opacity-[0.09] pointer-events-none"
            style={{
              backgroundImage:
                "linear-gradient(#E8E4D9 1px, transparent 1px), linear-gradient(90deg, #E8E4D9 1px, transparent 1px)",
              backgroundSize: "46px 46px",
            }}
          />
          <FounderRecord />
        </div>

        <div className="p-8 md:p-12 flex flex-col justify-center bg-paper">
          <motion.div
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <h2 className="font-display font-semibold tracking-[-0.02em] text-4xl md:text-5xl lg:text-6xl leading-[0.95] text-ink text-balance">
              Hi, I&apos;m Hamza. I built the{" "}
              <span className="font-editorial italic font-medium text-cobalt">$1.3M playbook.</span>
            </h2>
            <p className="mt-6 text-lg md:text-xl font-light leading-relaxed text-ink max-w-lg text-pretty">
              I've spent a decade selling, from cold outreach to enterprise deals. Now I build and manage the team that does it for you.
            </p>
            <div className="mt-7 flex flex-col sm:flex-row gap-4">
              <a
                href={LINKS.cal}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-2 bg-cobalt px-7 py-4 font-mono text-base uppercase tracking-[0.12em] text-white border border-ink transition-all duration-200 hover:-translate-y-1 hover:shadow-hard active:translate-y-0 active:shadow-none"
                data-testid="founder-book"
              >
                Book a meeting
                <ArrowUpRight size={18} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
              <a
                href={LINKS.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 border border-ink px-7 py-4 font-mono text-base uppercase tracking-[0.12em] text-ink transition-colors duration-200 hover:bg-ink hover:text-paper"
                data-testid="founder-linkedin"
              >
                Connect on LinkedIn
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
